/* gk-cart-timer — countdown persistente do carrinho */
(function () {
  const STORAGE_KEY = 'gkct_end_ts';

  function getOrCreateEnd(durationMin) {
    const now = Date.now();
    let stored = 0;
    try { stored = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10); } catch (e) {}
    const maxFuture = now + durationMin * 60 * 1000;
    if (!stored || stored < now || stored > maxFuture) {
      const newEnd = now + durationMin * 60 * 1000;
      try { localStorage.setItem(STORAGE_KEY, String(newEnd)); } catch (e) {}
      return newEnd;
    }
    return stored;
  }

  function startTimer(el) {
    if (!el || el.__gkctRunning) return;
    el.__gkctRunning = true;

    const duration = parseInt(el.dataset.duration || '5', 10);
    const totalMs = duration * 60 * 1000;
    const expired = el.dataset.expired || '';
    const msgEl = el.querySelector('[data-gkct-msg]');
    const timeEl = el.querySelector('[data-gkct-time]');
    const endTs = getOrCreateEnd(duration);

    function tick() {
      const now = Date.now();
      const remaining = Math.max(0, endTs - now);

      if (remaining <= 0) {
        clearInterval(el.__gkctInterval);
        el.__gkctInterval = null;
        if (msgEl) msgEl.textContent = expired;
        el.classList.remove('is-urgent');
        el.classList.add('is-expired');
        return;
      }

      const totalSec = Math.floor(remaining / 1000);
      const min = Math.floor(totalSec / 60);
      const sec = totalSec % 60;
      const formatted = String(min).padStart(2, '0') + ':' + String(sec).padStart(2, '0');
      if (timeEl) timeEl.textContent = formatted;
      el.style.setProperty('--gkct-pct', Math.min(100, (remaining / totalMs) * 100) + '%');
      el.classList.toggle('is-urgent', totalSec < 60);
    }

    tick();
    el.__gkctInterval = setInterval(tick, 1000);
  }

  function initAll() {
    document.querySelectorAll('gk-cart-timer').forEach(startTimer);
  }

  if (!customElements.get('gk-cart-timer')) {
    class GkCartTimer extends HTMLElement {
      connectedCallback() {
        startTimer(this);
      }
      disconnectedCallback() {
        if (this.__gkctInterval) {
          clearInterval(this.__gkctInterval);
          this.__gkctInterval = null;
        }
        this.__gkctRunning = false;
      }
    }
    customElements.define('gk-cart-timer', GkCartTimer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('cart:refresh', initAll);
})();
